import React from 'react';
import { Layout, Drawer, Icon } from 'antd';
import { inject, observer } from 'mobx-react';
import { css } from '@emotion/core';
import Logo from '../../components/Logo';
import { ButtonWithIcon } from '../../components/common/ButtonWithIcon';
import Header from './Header';
import { NotificationsMenu } from '../../components/NotificationsMenu';
import Sider from '../Sider';
import Toast from '../Toast';
import BifmSider from '../Bifm/BifmSider';

const { Header: AntHeader } = Layout;

@inject('sessionStore')
@inject('dashboardStore')
@observer
class MobileHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navigationDrawerVisible: false,
      accountDrawerVisible: false,
    };
  }

  componentDidMount = () => {
    const { dashboardStore } = this.props;
    dashboardStore.initStore();
  };

  showAccountDrawer = value => {
    this.setState({
      accountDrawerVisible: value || !this.state.accountDrawerVisible,
      navigationDrawerVisible: false,
    });
  };

  showNavigationDrawer = value => {
    this.setState({
      navigationDrawerVisible: value || !this.state.navigationDrawerVisible,
      accountDrawerVisible: false,
    });
  };

  render() {
    const {
      sessionStore: { isBifmUser },
    } = this.props;
    return (
      <>
        <Toast />
        <AntHeader
          css={{
            background: '#fff',
            borderBottom: 'solid #e9eaef 1px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0px 10px 0px 0px',
            height: '68px',
            position: 'sticky',
            top: 0,
            zIndex: '1300',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ width: '118px' }}>
              <Logo style={{ height: 68 }} />
            </div>

            <Icon
              type={this.state.navigationDrawerVisible ? 'menu-fold' : 'menu-unfold'}
              style={{
                fontSize: 20,
                marginLeft: 15,
                padding: 10,
                cursor: 'pointer',
                transition: '0.3s',
              }}
              onClick={() => this.showNavigationDrawer()}
            />
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: 65,
            }}
          >
            <NotificationsMenu mobileLayout />
            <ButtonWithIcon
              iconType="user"
              iconSize="28"
              onClick={() => this.showAccountDrawer()}
            />
          </div>

          <Drawer
            title="Basic Drawer"
            placement="right"
            css={css`
              & > .ant-drawer-content-wrapper {
                width: calc(100% - 118px) !important;
                max-width: 300px;
              }
            `}
            closable={false}
            visible={this.state.accountDrawerVisible}
            onClose={() => this.showAccountDrawer(false)}
          >
            <Header mobileLayout />
          </Drawer>

          <Drawer
            title="Navigation Drawer"
            placement="left"
            width="118px"
            closable={false}
            visible={this.state.navigationDrawerVisible}
            onClose={() => this.showNavigationDrawer(false)}
            css={css`
              .ant-drawer-body {
                padding: 0px;
              }
              .ant-drawer-header {
                height: 68px;
              }
            `}
          >
            {isBifmUser ? <BifmSider mobileLayout /> : <Sider mobileLayout />}
          </Drawer>
        </AntHeader>
      </>
    );
  }
}

export default MobileHeader;
